import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form } from 'react-bootstrap';
import {
  Screen,
  Text,
  Input,
  Label,
  Button,
  ButtonUpload,
  Calendar,
  File as FileDoc,
  Checkbox,
} from '../../../components';
import pressRoomService from '../../../services/pressroom';
import fileService from '../../../services/file';
import moment from 'moment';

const {
  defaultStates,
  defaultAlertScreenOnClick,
  defaultModalOnHide,
  baseURL,
} = require('../../../utils/defaults');

class PressRoom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pressroom: {
        title: '',
        newTitle: '',
        postingDate: '',
        files_document: [],
        url: '',
        isActive: true,
        type: 'releases',
      },
      ...defaultStates(),
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.alertScreenOnClick = this.alertScreenOnClick.bind(this);
    this.modalOnHide = this.modalOnHide.bind(this);
    this.body = this.body.bind(this);
    this.footer = this.footer.bind(this);
  }

  modalOnHide() {
    defaultModalOnHide(this);
  }

  alertScreenOnClick() {
    defaultAlertScreenOnClick(this);
  }

  async componentDidMount() {
    this.setState({ loadingState: true });

    const { id } = this.props.match.params;

    if (id !== 'novo') {
      const response = await pressRoomService.admin.get(id);
      if (response.ok && response.data && response.data.pressroom) {
        if (response.data.pressroom.postingDate) {
          const raw = response.data.pressroom.postingDate;
          response.data.pressroom.postingDate = moment(raw.substring(0, 10), 'YYYY-MM-DD').toDate();
        }

        this.setState({
          pressroom: response.data.pressroom,
          newRegister: false,
        });
      } else if (response.ok) {
        this.props.history.push('/gestao/pressroom/novo');
      } else {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };
        this.setState({ modalState });
      }
    }

    this.setState({ loadingState: false });
  }

  handleChange(id, event) {
    const { pressroom } = this.state;

    if (id === 'type') {
      const newType = event.target.value;
      pressroom[id] = newType;

      if (newType === 'midia') {
        pressroom.files_document = [];
        pressroom.file_id_document = null;
      } else {
        pressroom.url = '';
      }
    } else if (id === 'url') {
      pressroom[id] = event.target.value;

      if (pressroom[id]) {
        pressroom.files_document = [];
        pressroom.file_id_document = null;
      }
    } else if (id === 'removeFileDocument') {
      pressroom.files_document = [];
      pressroom.file_id_document = null;
    } else {
      pressroom[id] = event.target?.value ?? event?.target ?? event;
    }

    this.setState({ pressroom });
  }


  async handleSubmit() {
    const { newRegister, pressroom } = this.state;
    this.setState({ loadingState: true });

    pressroom.title = pressroom.newTitle || pressroom.title;
    delete pressroom.newTitle;
    if (pressroom.postingDate) {
      pressroom.postingDate = moment(pressroom.postingDate).utc().format('YYYY-MM-DD');
    }

    if (newRegister) {
      const response = await pressRoomService.admin.save(pressroom);
      if (response.ok) {
        const alertScreenState = {
          title: 'Documento criado com sucesso!',
          open: true,
          onClick: this.alertScreenOnClick,
          pagePath: '/gestao/pressroom',
        };

        this.setState({ alertScreenState });
      } else {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };

        this.setState({ modalState });
      }

    } else {
      const response = await pressRoomService.admin.edit(pressroom);
      if (response.ok) {
        const alertScreenState = {
          title: 'Documento alterado com sucesso!',
          open: true,
          onClick: this.alertScreenOnClick,
          pagePath: '/gestao/pressroom',
        };

        this.setState({ alertScreenState });
      } else {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };

        this.setState({ modalState });
      }
    }

    this.setState({ loadingState: false });
  }

  async handleDelete() {
    this.setState({
      modalState: {
        title: `Remoção de ${this.state.pressroom.isActive ? 'Documentos' : 'Rascunho'}`,
        text: `Tem certeza que deseja excluir esse${
          this.state.pressroom.isActive ? 'documento' : 'rascunho'
        }?`,
        toggle: true,
        onHide: () => this.modalOnHide(),
        confirm: 'Sim',
        onClickConfirm: async () => await _handleDelete(),
        danger: true,
        cancel: 'Não',
        onClickCancel: () => this.modalOnHide(),
      },
    });

    const _handleDelete = async () => {
      const {
        pressroom: { id },
      } = this.state;
      this.setState({ loadingState: true });

      const response = await pressRoomService.admin.delete(id);

      if (response.ok && response.data) {
        const alertScreenState = {
          title: 'Documento Excluido com sucesso!',
          open: true,
          onClick: this.alertScreenOnClick,
          pagePath: '/gestao/pressroom',
        };

        this.setState({ alertScreenState });
      } else {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };

        this.setState({ modalState });
      }

      this.setState({ loadingState: false });
    };
  }

  async handleUploadFileTiny(file, cb) {
    const response = await fileService.upload({ files: [file] });
    if (response.ok && response.data) {
      const file = response.data;

      cb(`${baseURL()}/api/file/${file.fileId}/${file.slug}`, {
        title: file.slug,
      });
    } else {
      const modalState = {
        title: 'Erro',
        text: response.message,
        toggle: true,
        onHide: this.modalOnHide,
      };

      this.setState({ modalState });
    }
  }

  body() {
    const { pressroom, modalFile } = this.state;
    const options = [
      { type: 'Releases', value: 'releases' },
      { type: 'FGCoop na mídia', value: 'midia' },
    ];

    return (
      <>
        <Row align="center">
          <Col>
            <Text title text={'Sala de Imprensa'} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Checkbox
              label={'Ativo'}
              checked={pressroom.isActive}
              onClick={() => {
                pressroom.isActive = !pressroom.isActive;
                this.setState({ pressroom });
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={4} xs={4}>
            <Label text={'Data da Postagem:'} />
            <Calendar
              label={'Data'}
              value={pressroom.postingDate}
              onChange={(e) => this.handleChange('postingDate', e)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12} xs={12}>
            <Input
              value={pressroom.title}
              label={'Título'}
              placeholder={'Título'}
              maxLength={200}
              onChange={(e) => this.handleChange('title', e)}
            />
          </Col>
        </Row>
        
         <Row>
          <Col sm={12} xs={12}>
            <Label text={'Selecione o Tipo:'} />
            <Form.Select
              size="lg"
              value={pressroom.type}
              onChange={(e) => {
                this.handleChange('type', e); 
                this.handleChange('removeFileDocument');
                this.handleChange('url', { target: { value: '' } });
              }}
            >
              {options.map((option, idx) => (
                <option key={idx} value={option.value}>
                  {option.type}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
        {pressroom.type === 'releases' ? (
          <>
            <Row>
              <Col>
                <Label text={'Documento:'} />
                <ButtonUpload
                  modal
                  onClickConfirm={(e) => {
                    this.handleChange('files_document', e);
                    this.setState({ modalFile: false });
                  }}
                  modalToggle={modalFile}
                  modalTitle={'ADICIONAR DOCUMENTO'}
                  modalOnHide={() => this.setState({ modalFile: false })}
                  onClick={() => this.setState({ modalFile: true })}
                />
              </Col>
            </Row>
              {pressroom.files_document.length > 0 ? (
                <Row align="center">
                  <Col>
                    <Text subTitle text="Documento Adicionado" />
                  </Col>
                </Row>
              ) : (
                ''
              )}
          </>
          ) : (
          <Row>
            <Col sm={6} xs={6}>
              <Input
                value={pressroom.url}
                label={'Url:'}
                placeholder={'Url'}
                maxLength={200}
                onChange={(e) => this.handleChange('url', e)}
              />
            </Col>
          </Row>
        )}
        
          <Row>
          {pressroom.type === 'midia' ? (
            ''
          ): (
            <>
              {pressroom.files_document.map((doc, index) => {
              return (
                <Col md={4} key={index}>
                  <FileDoc
                    fileName={doc.fileName ? doc.fileName : doc.name ? doc.name : 'Arquivo sem nome'}
                    fileTitle={doc.fileName ? doc.fileName : doc.name ? doc.name : 'Arquivo sem nome'}
                    onClick={() => this.handleChange('removeFileDocument')}
                    info={doc}
                  />
                </Col>
              );
              })}
            </>
          )}
        </Row>
      </>
    );
  }

  footer() {
    return (
      <>
        <Row align="center" className='mt-4'>
          {this.state.pressroom.id ? (
            <Col>
              <Button danger text={'Excluir'} onClick={this.handleDelete} />
            </Col>
          ) : (
            <></>
          )}
          <Col>
            <Button text={'Salvar'} onClick={this.handleSubmit} />
          </Col>
        </Row>
      </>
    );
  }

  render() {
    const { modalState, alertScreenState, loadingState } = this.state;

    return (
      <>
        <Screen
          admin
          body={this.body}
          footer={this.footer}
          modalState={modalState}
          alertScreenState={alertScreenState}
          loadingState={loadingState}
        />
      </>
    );
  }
}

PressRoom.propTypes = {
  //props
  match: PropTypes.object,
  history: PropTypes.object,
};

export default PressRoom;
